import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import InstallPrompt from "./components/InstallPrompt";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyPhone from "./pages/VerifyPhone";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ShipperDashboard from "./pages/ShipperDashboard";
import TransporterDashboard from "./pages/TransporterDashboard";
import CreateMission from "./pages/CreateMission";
import MissionDetail from "./pages/MissionDetail";
import KycCenter from "./pages/KycCenter";
import AdminPanel from "./pages/AdminPanel";
import PublicProfile from "./pages/PublicProfile";
import MentionsLegales from "./pages/Legal/MentionsLegales";
import CGU from "./pages/Legal/CGU";
import CGV from "./pages/Legal/CGV";
import Privacy from "./pages/Legal/Privacy";
import ContratTransport from "./pages/Legal/ContratTransport";
import Intermediation from "./pages/Legal/Intermediation";
import PrivacyAccount from "./pages/PrivacyAccount";
import Contact from "./pages/Contact";
import { resetDemoState } from "./lib/demoApi";

export default function App() {
  const demoMode = process.env.REACT_APP_DEMO_MODE === "1";
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <div className="min-h-screen flex flex-col bg-background text-foreground">
          {demoMode && (
            <div className="bg-amber-300 text-[#15302A] text-center text-xs font-semibold px-4 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
              <span>APERÇU PRIVÉ — données fictives, aucun paiement, SMS ou message réel · code SMS test : 123456</span>
              <button
                type="button"
                className="underline underline-offset-2 hover:no-underline"
                onClick={() => {
                  if (window.confirm("Réinitialiser toutes les données locales de la démonstration ?")) {
                    resetDemoState();
                    window.location.assign("/");
                  }
                }}
                data-testid="demo-reset"
              >
                Réinitialiser la démo
              </button>
            </div>
          )}
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-phone" element={
                <ProtectedRoute><VerifyPhone /></ProtectedRoute>
              } />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/mentions" element={<MentionsLegales />} />
              <Route path="/legal/cgu" element={<CGU />} />
              <Route path="/legal/terms" element={<CGU />} />
              <Route path="/legal/cgv" element={<CGV />} />
              <Route path="/legal/contrat-transport" element={<ContratTransport />} />
              <Route path="/legal/intermediation" element={<Intermediation />} />
              <Route path="/legal/privacy" element={<Privacy />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/account/privacy" element={
                <ProtectedRoute><PrivacyAccount /></ProtectedRoute>
              } />
              <Route path="/u/:id" element={<PublicProfile />} />
              <Route path="/shipper" element={
                <ProtectedRoute allowedRoles={["shipper", "admin"]}><ShipperDashboard /></ProtectedRoute>
              } />
              <Route path="/missions/new" element={
                <ProtectedRoute allowedRoles={["shipper", "admin"]}><CreateMission /></ProtectedRoute>
              } />
              <Route path="/missions/:id" element={
                <ProtectedRoute><MissionDetail /></ProtectedRoute>
              } />
              <Route path="/transporter" element={
                <ProtectedRoute allowedRoles={["transporter", "admin"]}><TransporterDashboard /></ProtectedRoute>
              } />
              <Route path="/kyc" element={
                <ProtectedRoute allowedRoles={["transporter", "admin"]}><KycCenter /></ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>
              } />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
          <CookieBanner />
          <InstallPrompt />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}
